import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { IconArrowNarrowRight } from "@tabler/icons-react";

const Creativity = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      <section
        className="about-section overflow-hidden bg-light"
        style={{ marginTop: "-80px" }}
      >
        <div className="container">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 mt-3">
              <div className="container relative">
                <div className="section grid grid-cols-12 items-center justify-center gap-6 xxxl:pb-[259px] xxxl:pt-[230px]">
                  <div
                    className="col-span-12 md:col-span-10 lg:col-span-6"
                    data-aos="fade-right"
                  >
                    <div className="section__gap-bottom pb-lg-0">
                      <h5
                        className="h5 mb-5"
                        style={{ color: "rgb(0, 109, 178)" }}
                      >
                        <i className="ti ti-icon"></i> Boost Creativity with
                        Reliable Tech Solutions
                      </h5>
                      <h3 className="h3 mb-4 text-title">About Us</h3>
                      <p className="mb-10 text-lg">
                        Cognity Info Solutions ensures that the system operates
                        without hiccups and is responsive by paying attention to
                        even the smallest of details. Minified Technology is a
                        novel approach that Cognity Info Solutions uses for the
                        purpose of safeguarding the database of its clients and
                        constructing extremely secret firewalls.
                      </p>
                      <a href="/about-us" className="btn-primary">
                        <IconArrowNarrowRight className="text-blue-600 w-6 h-6" />
                        Find out More
                      </a>
                    </div>
                  </div>
                  <div
                    className="relative col-span-12 lg:col-span-6"
                    data-aos="fade-left"
                  >
                    <div className="about-img">
                      <div className="-top-40 xxl:absolute xxl:-right-24">
                        <img
                          src="assets/images/about-img-2.webp"
                          alt="image"
                          className="rounded-2xl"
                          width="640"
                          height="394"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Creativity;
